/* eslint-disable indent */
import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from 'react';
import qs from 'qs';
import { useLocation, useNavigate } from 'react-router-dom';
import MainBackupVideoPlayer from './components/MainBackupVideoPlayer';
import TrafficLight from '@/components/TrafficLight';
import './index.scss';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/redux/store';
import { setTakeOverInfo } from '@/redux/reducers/issue';
import BussinessApi from '@/fetch/bussiness';
import ThreeMonitorMap from './components/ThreeMonitorMap';
import Enable from '@/components/Enable';
import StatusFields from './components/StatusFields';
import {
  CollectMapMode,
  LOCALIZATION_ACCURACY,
  RemoteCommandType,
  CollectionStatus,
} from '@/utils/constant';
import { useIsTakeOverBySelf } from '@/utils/hooks';
import {
  cloudFetchConfig,
  debounce,
  getClstag,
  isObstacle,
  returnDashboardOptions,
  translatorEnum,
} from '@/utils/util';
import LocationIcon from '@/assets/images/monitor/location-icon.png';
import { Method } from '@/fetch/core/util';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { Modal, Spin, message } from 'antd';
import CallFrontLiner from './components/CallFrontliner';
import IssueHistoryBtn from './components/IssueHistory';
import AsArrived from './components/AsArrived';
import Restart from './components/Restart';
import Lights from './components/Lights';
import GearPosition from './components/GearPosition';
import SpeedControl from './components/SpeedControl';
import Dashboard from '@/components/Dashboard';
import classNames from 'classnames';
import TakeoverSetting from './components/TakeoverSetting';
import AcceleratorOpen from './components/AcceleratorOpen';
import { CockpitMode, CockpitStatus, TaskDetail } from '@/utils/type';
import { showModal } from '@/components/Modal';
import Navigation from './components/Navigation';
import { sendGlobalEvent } from '@/utils/emit';
import EnterCollectMap from './components/EnterCollectMap';
import CheckCollectRoute from './components/CheckCollectRoute';
import FinishCollectMap from './components/FinishCollectMap';
import ExitCollectMap from './components/ExitCollectMap';
import CollectRouteMap from '@/components/CollectRouteMap';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import ResumeCollectMap from './components/ResumeCollectMap';
import PauseCollectMap from './components/PauseCollectMap';
import Resolution, { RESOLUTION } from '@/components/Resolution';
import MapTaskCard from './components/MapTaskCard';
import CheckSolidifiedData from './components/CheckSolidifiedData';
import RealtimeMap, { RealtimeMapEtaInfo } from './components/RealtimeMap';
import VehicleCommand from './components/VehicleCommand';
import TakeOver from './components/TakeOver';
import WordOrderCommand from './components/WorkOrderCommand';
import RemarkStack, { RemarkItem } from '@/components/RemarkStack';
import { RemarkBannerType } from '@/components/RemarkBanner';
import FrontVideoPlayer from './components/FrontVideoPlayer';
import VideoDirectionWithBtn from './components/VideoDirectionWithBtn';
import { updateRealtime } from '@/redux/reducers/realtime';
import AEBAlertBar from './components/AEBAlertBar';
import { CockpitRealtimeErrorCode, ScheduleStateEnum } from '@/utils/enum';

const requestApi = new BussinessApi();
const fetchApi = new CollectMapApi();
const enbaleLayout = {
  conBgSide: 200, // 底部圆圈背景的宽高,
  carWidth: 150, // 小车宽高
  carHeight: 150,
  obstacleWidth: 100, // 四周图表的宽高
  obstacleHeight: 60,
};

// 视频加载优先级控制：前(0) -> 后(1) -> 左(2) -> 右(3)
const videoLoadOrder = ['front', 'back', 'left', 'right'];
const VEHICLE_DEGRADATION_TOAST_KEY = 'single-view-vehicle-degradation';
const VEHICLE_DEGRADATION_TOAST_DURATION = 5;

type VehicleDegradationLevel = {
  value?: unknown;
  name?: unknown;
};

type DegradationToastType = 'warning' | 'error';

const getVehicleDegradationLevel = (
  level: unknown
): VehicleDegradationLevel | null => {
  if (!level || typeof level !== 'object' || Array.isArray(level)) {
    return null;
  }

  return level as VehicleDegradationLevel;
};

const getVehicleDegradationValue = (level: unknown) => {
  const degradationLevel = getVehicleDegradationLevel(level);
  return String(degradationLevel?.value || '').trim();
};

const getVehicleDegradationMessage = (level: unknown) => {
  const degradationLevel = getVehicleDegradationLevel(level);
  return String(degradationLevel?.name || '').trim();
};

const getVehicleDegradationToastType = (
  value: string
): DegradationToastType => {
  if (
    value === 'DEG_L2_MISSION_TERMINATE' ||
    value === 'DEG_L3_EMERGENCY_BRAKE'
  ) {
    return 'error';
  }

  return 'warning';
};

const SingleView = () => {
  const router = useLocation();
  const dispatch = useDispatch();
  const cockpitRealtime = useSelector(
    (state: RootState) => state.cockpitRealtime
  );
  const login = useSelector((state: RootState) => state.login);
  const newCommon = useSelector((state: RootState) => state.newCommon);
  const controlBtn = useSelector((state: RootState) => state.controlBtn);
  const realtime = useSelector((state: RootState) => state.realtime);

  const isMountedRef = useRef(true);
  const shouldPollRef = useRef<boolean>(false); // 标记是否应该进行轮询
  const timerIdRef = useRef<NodeJS.Timeout | null>(null);
  const isPollingRef = useRef(false);
  const pendingVisibleRefreshRef = useRef(false);
  const pollTickRef = useRef(0);
  const latestScheduleStateRef = useRef<string | undefined>();
  const lastDegradationToastKeyRef = useRef('');
  const navigator = useNavigate();
  const realtimeMapRef = useRef<any>(null);
  const {
    enableFront,
    enableBack,
    enableLeft,
    enableRight,
    delay,
    frontAngle,
    velocity,
    drivingMode,
    headLight,
    turnLeft,
    turnRight,
    warningFlash,
    gearPosition,
    errorCode,
  } = cockpitRealtime;
  const [videoUrl, setVideoUrl] = useState<any>({});
  const queryList: any = router.search.split('?')[1];
  const query = qs.parse(queryList);
  const vehicleName: string = query.vehicleName;
  const { cockpitNumber } = newCommon;
  const { realtimeData } = realtime; // Get realtimeData from Redux
  const [loading, setLoading] = useState<any>(false);
  const [taskDetail, setTaskDetail] = useState<TaskDetail | null>(null);
  const [etaInfo, setEtaInfo] = useState<RealtimeMapEtaInfo | null>(null);
  const updateGoneRoute = useMemo(() => Date.now(), []);

  const [currentLoadingIndex, setCurrentLoadingIndex] = useState(0);
  const handleVideoLoadComplete = useCallback(() => {
    setCurrentLoadingIndex((prev) => {
      if (prev < videoLoadOrder.length - 1) {
        const nextIndex = prev + 1;
        return nextIndex;
      }
      return prev;
    });
  }, [videoLoadOrder]);
  const shouldLoadBack = useMemo(() => {
    const shouldLoad = 1 <= currentLoadingIndex;
    return shouldLoad;
  }, [currentLoadingIndex]);

  const shouldLoadLeft = useMemo(() => {
    const shouldLoad = 2 <= currentLoadingIndex;
    return shouldLoad;
  }, [currentLoadingIndex]);

  const shouldLoadRight = useMemo(() => {
    const shouldLoad = 3 <= currentLoadingIndex;
    return shouldLoad;
  }, [currentLoadingIndex]);

  const takeOverBySelf = useIsTakeOverBySelf();
  const userName = login.userInfo?.userName;
  const vehicleData = useMemo(
    () => ({
      vehicleState: takeOverBySelf ? drivingMode : realtimeData?.vehicleState,
      velocity: takeOverBySelf
        ? (velocity ?? 0) * 3.6
        : (realtimeData?.speed ?? 0) * 3.6,
      delay: takeOverBySelf ? delay : '--',
    }),
    [
      delay,
      drivingMode,
      realtimeData?.speed,
      realtimeData?.vehicleState,
      takeOverBySelf,
      velocity,
    ]
  );
  const isCollectionMode =
    realtimeData?.collectionMode === CollectMapMode.COLLECTION;
  const isMapCollectionCockpit =
    newCommon?.cockpitMode === CockpitMode.MAP_COLLECTION_MODE;
  const showThreeMonitorMap = !(isMapCollectionCockpit && isCollectionMode);
  const showCollectTaskCard = isMapCollectionCockpit && isCollectionMode;
  const showFooterWordOrder =
    newCommon?.cockpitMode !== CockpitMode.MAP_COLLECTION_MODE;
  const showCollectionTools =
    isMapCollectionCockpit &&
    realtimeData?.collectionMode !== CollectMapMode.COLLECTION;
  const showCollectionControls = isMapCollectionCockpit && isCollectionMode;
  const backVideoClosed = realtimeData?.videoStatus?.back === 'CLOSE';
  const leftVideoClosed = realtimeData?.videoStatus?.left === 'CLOSE';
  const rightVideoClosed = realtimeData?.videoStatus?.right === 'CLOSE';

  // 此时此刻车端上报的「翻译后的错误码」list
  const errorCodeTranslateList: string[] | undefined =
    realtimeData?.errorCodeTranslateList;
  // 将翻译后的错误码拼接成字符串
  const criticalRemarkMessage: string | undefined = Array.isArray(
    errorCodeTranslateList
  )
    ? errorCodeTranslateList.filter(Boolean).join('; ')
    : undefined;

  // 此时此刻车端上报的「地图变量异常」信息
  const mapVariableRemarkMessage: string | undefined =
    realtimeData?.mapVariableRemark;
  // 告警事件列表中过滤出地图变量异常相关的告警事件
  const mapVariableIssue = realtimeData?.alarmEventNameList?.filter(
    (item: any) => item === 'ATTENTION_REGION_WARN'
  );
  const degradationValue = getVehicleDegradationValue(
    realtimeData?.degradationLevel
  );
  const degradationMessage = getVehicleDegradationMessage(
    realtimeData?.degradationLevel
  );
  const degradationToastType =
    getVehicleDegradationToastType(degradationValue);

  /**
   * 计算浮层的提示信息
   * 根据地图变量异常信息和翻译后的错误码列表来决定是否展示浮层的提示信息
   * 列表排序逻辑代表着提示浮层的展示顺序，错误码在上面，地图变量异常在下面
   */
  const remarkItems: RemarkItem[] = useMemo(
    () => [
      {
        id: 'criticalRemark',
        type: RemarkBannerType.CRITICAL,
        visible:
          Array.isArray(errorCodeTranslateList) &&
          errorCodeTranslateList.length > 0,
        message: criticalRemarkMessage,
      },
      {
        id: 'mapVariableRemark',
        type: RemarkBannerType.NORMAL,
        visible: Boolean(
          mapVariableIssue?.length > 0 && mapVariableRemarkMessage
        ),
        message: mapVariableRemarkMessage,
      },
    ],
    [
      criticalRemarkMessage,
      errorCodeTranslateList,
      mapVariableIssue?.length,
      mapVariableRemarkMessage,
    ]
  );

  const showRecommendClose3d =
    takeOverBySelf &&
    realtimeData?.localViewStatus === 'OPEN' &&
    (realtimeData?.signalQuality === 'FAIR' ||
      realtimeData?.signalQuality === 'POOR' ||
      realtimeData?.signalQuality === 'GOOD');
  const showRecommendCloseLeft =
    takeOverBySelf &&
    realtimeData?.videoStatus?.left === 'OPEN' &&
    (realtimeData?.signalQuality === 'FAIR' ||
      realtimeData?.signalQuality === 'POOR');
  const showRecommendCloseRight =
    takeOverBySelf &&
    realtimeData?.videoStatus?.right === 'OPEN' &&
    (realtimeData?.signalQuality === 'FAIR' ||
      realtimeData?.signalQuality === 'POOR');
  const showRecommendCloseBack =
    takeOverBySelf &&
    realtimeData?.videoStatus?.back === 'OPEN' &&
    realtimeData?.signalQuality === 'POOR';

  const newTakeover =
    (realtimeData?.driveInMqtt1Online !== null &&
      realtimeData?.driveInMqtt1Online !== undefined) ||
    (realtimeData?.driveInMqtt2Online !== null &&
      realtimeData?.driveInMqtt2Online !== undefined);

  const sendRemoteCommand = useCallback(
    (commandType: RemoteCommandType) => {
      requestApi.buttonCommand({
        cockpitNumber: newCommon.cockpitNumber,
        vehicleName: vehicleName,
        cockpitUserName: userName,
        remoteCommandType: commandType,
      });
    },
    [newCommon.cockpitNumber, userName, vehicleName]
  );

  const getExplorationTaskDetail = async (taskId: number) => {
    try {
      const res = await fetchApi.getExplorationTaskDetail(taskId);
      if (!isMountedRef.current) return;
      if (res.code === HttpStatusCode.Success) {
        setTaskDetail(res.data);
      } else {
        message.error(res.message || '操作失败');
        setTaskDetail(null);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    let modalInstance: any = null;
    if (realtimeData?.cockpitStatus === CockpitStatus.OFFLINE) {
      modalInstance = Modal.confirm({
        width: 800,
        content: '您已断线，请重新入座座席',
        okText: takeOverBySelf ? '退出接管并前往入座' : '前往入座',
        onOk: () => {
          navigator('/app/home');
        },
      });
    }
    return () => {
      if (modalInstance) {
        modalInstance.destroy();
      }
    };
  }, [realtimeData?.cockpitStatus, takeOverBySelf, navigator]);

  useEffect(() => {
    setLoading(realtimeData?.isSwitchStatus);
  }, [realtimeData?.isSwitchStatus]);
  useEffect(() => {
    if (!vehicleName || !degradationMessage) {
      lastDegradationToastKeyRef.current = '';
      return;
    }

    const nextToastKey = [
      vehicleName,
      degradationValue,
      degradationMessage,
    ].join('|');

    if (lastDegradationToastKeyRef.current === nextToastKey) {
      return;
    }

    lastDegradationToastKeyRef.current = nextToastKey;
    message.open({
      key: VEHICLE_DEGRADATION_TOAST_KEY,
      type: degradationToastType,
      content: degradationMessage,
      duration: VEHICLE_DEGRADATION_TOAST_DURATION,
    });
  }, [degradationMessage, degradationToastType, degradationValue, vehicleName]);
  useEffect(() => {
    if (realtimeData?.taskId) {
      getExplorationTaskDetail(realtimeData?.taskId);
    } else {
      setTaskDetail(null);
    }
  }, [realtimeData?.taskId]);
  useEffect(() => {
    if (!vehicleName) {
      return;
    }

    const { promise, cancel } = requestApi.fetchVideoPlayUrl(vehicleName);

    promise
      .then((res: any) => {
        if (!isMountedRef.current) return;
        const data = res.data;
        if (!data) {
          return;
        }
        setVideoUrl({
          front: { main: data.front, slave: data.frontSlave },
          back: { main: data.back, slave: data.backSlave },
          left: { main: data.left, slave: data.leftSlave },
          right: { main: data.right, slave: data.rightSlave },
          audio: data.audio,
          camera360Front: data.camera360Front,
        });
      })
      .catch((error: any) => {
        // 当请求被取消时，cancellableRequest 内部已处理，这里只处理其他真实错误
        if (error.code !== 'FETCH_ABORTED') {
          console.error('Fetch video URL error:', error);
        }
      });

    return () => {
      cancel();
    };
  }, [vehicleName]);

  const isEtaScheduleState = useCallback((scheduleState?: string | null) => {
    return (
      scheduleState === ScheduleStateEnum.SETOUT ||
      scheduleState === ScheduleStateEnum.RETURN
    );
  }, []);

  const clearPollTimer = useCallback(() => {
    if (timerIdRef.current) {
      clearTimeout(timerIdRef.current);
      timerIdRef.current = null;
    }
  }, []);

  const clearEtaInfo = useCallback(() => {
    setEtaInfo((prev) => (prev ? null : prev));
  }, []);

  const getSingleVehicle = useCallback(async () => {
    if (!vehicleName || !cockpitNumber) {
      return null;
    }

    try {
      const res = await request({
        path: '/monitor/web/cockpit/getSingleVehicle',
        method: Method.POST,
        body: {
          vehicleName,
          cockpitNumber,
        },
      });

      if (!isMountedRef.current) {
        return null;
      }

      if (res.code !== HttpStatusCode.Success) {
        return null;
      }

      const data = {
        ...(res?.data || {}),
        globalMileage: res?.data?.globalMileage
          ? res?.data?.globalMileage / 1000
          : 0,
        arrivedMileage: res?.data?.arrivedMileage
          ? res?.data?.arrivedMileage / 1000
          : 0,
        latitude: res?.data?.latitude,
        longitude: res?.data?.longitude,
      };

      latestScheduleStateRef.current = data.scheduleState;
      dispatch(
        setTakeOverInfo({
          takeOverUserName: data.takeOverUserName,
          takeOverCockpitNumber: data.takeOverCockpitNumber,
        })
      );
      dispatch(updateRealtime(data));

      return data;
    } catch (e) {
      console.error('获取车辆信息失败:', e);
      return null;
    }
  }, [cockpitNumber, dispatch, vehicleName]);

  const getEtaInfo = useCallback(
    async (scheduleState: string) => {
      if (!vehicleName || !isEtaScheduleState(scheduleState)) {
        return null;
      }

      try {
        const res = await request({
          path: '/monitor/web/cockpit/getEtaInfo',
          method: Method.POST,
          body: {
            vehicleName,
          },
        });

        if (!isMountedRef.current) {
          return null;
        }

        if (
          res.code !== HttpStatusCode.Success ||
          latestScheduleStateRef.current !== scheduleState
        ) {
          return null;
        }

        const nextEtaInfo = {
          vehicleScheduleState: scheduleState,
          estimatedArrivalTime: res.data?.estimatedArrivalTime,
          nextMileage: res.data?.nextMileage,
        };

        setEtaInfo((prev) => {
          if (
            prev?.vehicleScheduleState === nextEtaInfo.vehicleScheduleState &&
            prev?.estimatedArrivalTime === nextEtaInfo.estimatedArrivalTime &&
            prev?.nextMileage === nextEtaInfo.nextMileage
          ) {
            return prev;
          }

          return nextEtaInfo;
        });

        return nextEtaInfo;
      } catch (e) {
        console.error('获取ETA信息失败:', e);
        return null;
      }
    },
    [isEtaScheduleState, vehicleName]
  );

  const runPollingTick = useCallback(
    async (forceEta = false) => {
      if (!shouldPollRef.current) {
        return;
      }

      if (document.hidden) {
        pendingVisibleRefreshRef.current = true;
        return;
      }

      if (isPollingRef.current) {
        if (forceEta) {
          pendingVisibleRefreshRef.current = true;
        }
        return;
      }

      pendingVisibleRefreshRef.current = false;
      isPollingRef.current = true;

      try {
        const data = await getSingleVehicle();
        if (!data) {
          return;
        }

        const currentTick = pollTickRef.current;
        pollTickRef.current += 1;

        if (isEtaScheduleState(data.scheduleState)) {
          const shouldFetchEta = forceEta || currentTick % 3 === 0;
          if (shouldFetchEta) {
            await getEtaInfo(data.scheduleState);
          }
        } else {
          clearEtaInfo();
        }
      } catch (_) {
        console.error('轮询获取车辆信息失败');
      } finally {
        isPollingRef.current = false;

        if (!shouldPollRef.current) {
          return;
        }

        if (document.hidden) {
          pendingVisibleRefreshRef.current = true;
          clearPollTimer();
          return;
        }

        clearPollTimer();

        if (pendingVisibleRefreshRef.current) {
          pendingVisibleRefreshRef.current = false;
          timerIdRef.current = setTimeout(() => {
            runPollingTick(true);
          }, 0);
          return;
        }

        timerIdRef.current = setTimeout(() => {
          runPollingTick();
        }, 1000);
      }
    },
    [
      clearEtaInfo,
      clearPollTimer,
      getEtaInfo,
      getSingleVehicle,
      isEtaScheduleState,
    ]
  );

  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      clearPollTimer();
      return;
    }

    if (!shouldPollRef.current) {
      return;
    }

    clearPollTimer();

    if (isPollingRef.current) {
      pendingVisibleRefreshRef.current = true;
      return;
    }

    runPollingTick(true);
  }, [clearPollTimer, runPollingTick]);

  useEffect(() => {
    if (
      realtimeData?.videoMode === RESOLUTION.ULTRAFAST ||
      (realtimeData?.videoMode === RESOLUTION.AUTO &&
        realtimeData?.signalQuality === 'POOR' &&
        takeOverBySelf)
    ) {
      try {
        request({
          path: '/monitor/web/drive/command/send/velocity-control',
          method: Method.POST,
          body: {
            vehicleName: vehicleName,
            cockpitNumber: cockpitNumber,
            cockpitUserName: userName,
            data: Math.floor((5 / 3.6) * 100) / 100,
          },
        }).then((res) => {
          if (!isMountedRef.current) return;
          if (res.code === HttpStatusCode.Success) {
            sendGlobalEvent('set-velocity-control', 5);
          }
        });
      } catch (_) {}
    }
  }, [
    cockpitNumber,
    realtimeData?.videoMode,
    realtimeData?.signalQuality,
    takeOverBySelf,
    userName,
    vehicleName,
  ]);

  useEffect(() => {
    if (!cockpitNumber || !vehicleName) {
      latestScheduleStateRef.current = undefined;
      clearEtaInfo();
      return;
    }

    shouldPollRef.current = true;
    pendingVisibleRefreshRef.current = false;
    pollTickRef.current = 0;
    latestScheduleStateRef.current = undefined;
    clearEtaInfo();
    runPollingTick(true);

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      shouldPollRef.current = false;
      pendingVisibleRefreshRef.current = false;
      latestScheduleStateRef.current = undefined;
      clearPollTimer();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [
    clearEtaInfo,
    clearPollTimer,
    cockpitNumber,
    handleVisibilityChange,
    runPollingTick,
    vehicleName,
  ]);

  const goBack = useCallback(() => {
    if (takeOverBySelf) {
      message.error('请先退出车辆接管');
      return;
    }
    navigator('/app/multivehicle');
  }, [navigator, takeOverBySelf]);

  const refreshSingleVehicle = useCallback(() => {
    getSingleVehicle();
  }, [getSingleVehicle]);

  const pauseOrResumeBtn = useMemo(() => {
    if (
      !realtimeData?.collectionStatus ||
      realtimeData?.collectionStatus === CollectionStatus.NOT_STARTED ||
      realtimeData?.collectionStatus === CollectionStatus.PAUSED
    ) {
      return (
        <ResumeCollectMap
          vehicleName={vehicleName}
          cockpitNumber={cockpitNumber}
          bindingState={realtimeData?.bindingState}
          taskId={realtimeData?.taskId}
          systemState={realtimeData?.systemState}
          onClose={refreshSingleVehicle}
        />
      );
    }

    return (
      <PauseCollectMap
        vehicleName={vehicleName}
        cockpitNumber={cockpitNumber}
        taskId={realtimeData?.taskId}
        systemState={realtimeData?.systemState}
        onClose={refreshSingleVehicle}
      />
    );
  }, [
    cockpitNumber,
    realtimeData?.bindingState,
    realtimeData?.collectionStatus,
    realtimeData?.systemState,
    realtimeData?.taskId,
    refreshSingleVehicle,
    vehicleName,
  ]);

  const onChangeResolution = useCallback(
    (value: RESOLUTION, mesFlag = true) => {
      try {
        request({
          ...cloudFetchConfig('/monitor/web/video/changeMode'),
          method: Method.POST,
          body: {
            vehicleName: vehicleName,
            videoMode: value,
            source: 'REMOTE_JOYSTICK',
          },
        }).then((res) => {
          if (!isMountedRef.current) return;
          if (res.code === HttpStatusCode.Success) {
            mesFlag && message.success('清晰度切换成功');
          }
        });
      } catch (_) {}
    },
    [vehicleName]
  );

  useEffect(() => {
    const debouncedGoBack = debounce(goBack, 500);
    if (
      controlBtn.LC_BUTTON_MINUS &&
      !(
        takeOverBySelf &&
        errorCode === CockpitRealtimeErrorCode.ERROR_VEHICLE_AEB_IS_TRUE
      )
    ) {
      debouncedGoBack();
    }
  }, [controlBtn.LC_BUTTON_MINUS, errorCode, goBack, takeOverBySelf]);

  const operate3d = useCallback(async () => {
    const isOpenAction = realtimeData?.localViewStatus === 'CLOSE';
    try {
      const res = await request({
        method: 'POST',
        path: '/monitor/web/cockpit/operate3d',
        body: {
          vehicleName: vehicleName,
          operateType: isOpenAction ? 'OPEN' : 'CLOSE',
        },
      });
      if (!isMountedRef.current) return;
      if (res.code === HttpStatusCode.Success) {
        message.success(`${isOpenAction ? '开启' : '关闭'}3d成功`);
      } else {
        message.error(res.message || `${isOpenAction ? '开启' : '关闭'}3d失败`);
      }
    } catch (_) {}
  }, [realtimeData?.localViewStatus, vehicleName]);
  const operateVideo = useCallback(
    async (direction: string, action: 'CLOSE' | 'OPEN') => {
      if (!takeOverBySelf) {
        return;
      }
      try {
        const res = await request({
          method: 'POST',
          path: '/monitor/web/cockpit/operateVideo',
          body: {
            vehicleName: vehicleName,
            operateType: action,
            videoDirection: [direction],
          },
        });
        if (!isMountedRef.current) return;
        if (res.code === HttpStatusCode.Success) {
          message.success(`${action === 'CLOSE' ? '关闭' : '开启'}视频成功`);
        } else {
          message.error(
            res.message || `${action === 'CLOSE' ? '关闭' : '开启'}视频失败`
          );
        }
      } catch (_) {}
    },
    [takeOverBySelf, vehicleName]
  );

  useEffect(() => {
    if (takeOverBySelf && controlBtn?.LC_BUTTON_L3) {
      showRecommendClose3d && operate3d();
      showRecommendCloseLeft && operateVideo('LEFT', 'CLOSE');
      showRecommendCloseRight && operateVideo('RIGHT', 'CLOSE');
      showRecommendCloseBack && operateVideo('BACK', 'CLOSE');
    }
  }, [
    controlBtn?.LC_BUTTON_L3,
    operate3d,
    operateVideo,
    showRecommendClose3d,
    showRecommendCloseBack,
    showRecommendCloseLeft,
    showRecommendCloseRight,
    takeOverBySelf,
  ]);

  // For Back Video
  const openBackVideo = useCallback(
    () => operateVideo('BACK', 'OPEN'),
    [operateVideo]
  );
  const closeBackVideo = useCallback(
    () => operateVideo('BACK', 'CLOSE'),
    [operateVideo]
  );
  const backDirection = useMemo(
    () => (
      <VideoDirectionWithBtn
        direction="后"
        showRecommendCloseBtnText={showRecommendCloseBack}
        showRecommendCloseBtnIcon={
          takeOverBySelf && realtimeData?.videoStatus?.back === 'OPEN'
        }
        closeVideo={closeBackVideo}
      />
    ),
    [
      showRecommendCloseBack,
      takeOverBySelf,
      realtimeData?.videoStatus?.back,
      closeBackVideo,
    ]
  );

  // For Left Video
  const openLeftVideo = useCallback(
    () => operateVideo('LEFT', 'OPEN'),
    [operateVideo]
  );
  const closeLeftVideo = useCallback(
    () => operateVideo('LEFT', 'CLOSE'),
    [operateVideo]
  );
  const leftDirection = useMemo(
    () => (
      <VideoDirectionWithBtn
        direction="左"
        showRecommendCloseBtnText={showRecommendCloseLeft}
        showRecommendCloseBtnIcon={
          takeOverBySelf && realtimeData?.videoStatus?.left === 'OPEN'
        }
        closeVideo={closeLeftVideo}
      />
    ),
    [
      showRecommendCloseLeft,
      takeOverBySelf,
      realtimeData?.videoStatus?.left,
      closeLeftVideo,
    ]
  );

  // For Right Video
  const openRightVideo = useCallback(
    () => operateVideo('RIGHT', 'OPEN'),
    [operateVideo]
  );
  const closeRightVideo = useCallback(
    () => operateVideo('RIGHT', 'CLOSE'),
    [operateVideo]
  );
  const rightDirection = useMemo(
    () => (
      <VideoDirectionWithBtn
        direction="右"
        showRecommendCloseBtnText={showRecommendCloseRight}
        showRecommendCloseBtnIcon={
          takeOverBySelf && realtimeData?.videoStatus?.right === 'OPEN'
        }
        closeVideo={closeRightVideo}
      />
    ),
    [
      showRecommendCloseRight,
      takeOverBySelf,
      realtimeData?.videoStatus?.right,
      closeRightVideo,
    ]
  );

  const frontWarning = useMemo(() => isObstacle(enableFront), [enableFront]);
  const backWarning = useMemo(() => isObstacle(enableBack), [enableBack]);
  const leftWarning = useMemo(() => isObstacle(enableLeft), [enableLeft]);
  const rightWarning = useMemo(() => isObstacle(enableRight), [enableRight]);
  const gpsIcon = useMemo(
    () =>
      LOCALIZATION_ACCURACY[`LOCALIZATION_ACCURACY_${realtimeData?.gpsSignal}`]
        ?.icon,
    [realtimeData?.gpsSignal]
  );
  const angleDashboardOptions = useMemo(
    () =>
      returnDashboardOptions({
        currentValue: frontAngle <= 0.1 ? 0.1 : frontAngle * 2,
        clockwise: frontAngle < 0,
      }),
    [frontAngle]
  );
  const speedValueText = useMemo(
    () => vehicleData.velocity.toFixed(1),
    [vehicleData.velocity]
  );
  const speedDashboardOptions = useMemo(
    () =>
      returnDashboardOptions({
        currentValue: (Math.abs(Number(speedValueText) || 0) / 5) * 18,
        startAngle: 198,
        endAngle: -162,
        clockwise: true,
      }),
    [speedValueText]
  );
  const enableState = useMemo(
    () => ({
      enableFront,
      enableRight,
      enableBack,
      enableLeft,
    }),
    [enableBack, enableFront, enableLeft, enableRight]
  );
  const frontVideoClass = useMemo(() => {
    if (gearPosition === 'R' && gearPosition !== undefined) {
      return takeOverBySelf ? 'back-video' : 'front-video';
    }
    return 'front-video';
  }, [gearPosition, takeOverBySelf]);
  const backVideoClass = useMemo(() => {
    if (gearPosition === 'R' && gearPosition !== undefined) {
      return takeOverBySelf ? 'front-video' : 'back-video';
    }
    return 'back-video';
  }, [gearPosition, takeOverBySelf]);
  const handleCollectMapLoading = useCallback(() => {
    setLoading(true);
  }, []);
  const handleOpenNavigation = useCallback(() => {
    let path: any = [];
    showModal({
      title: '路线规划',
      width: 1000,
      content: (
        <Navigation
          vehicleName={vehicleName}
          handleNavigate={(routing: any) => {
            if (routing && routing.length > 0) {
              path = routing;
            }
          }}
        />
      ),
      footer: {
        showCancel: true,
        showOk: true,
        cancelFunc: (cb) => cb(),
        cancelText: '取消',
        okText: '确定',
        okFunc: (cb) => {
          realtimeMapRef.current?.customRouting(path);
          cb();
        },
      },
    });
  }, [vehicleName]);

  const videoSection = useMemo(
    () => (
      <>
        <div className={frontVideoClass}>
          {videoUrl.front && (
            <FrontVideoPlayer
              key={'front'}
              mainUrl={videoUrl.front.main!}
              slaveUrl={videoUrl.front.slave!}
              vehicleName={vehicleName}
              warning={frontWarning}
              takeOverBySelf={takeOverBySelf}
              camera360Front={videoUrl?.camera360Front!}
              gearPosition={gearPosition}
              userName={userName}
              shouldLoad={true}
              onVideoReady={handleVideoLoadComplete}
              onVideoTimeout={handleVideoLoadComplete}
            />
          )}
        </div>
        <div className={backVideoClass}>
          {videoUrl.back && (
            <MainBackupVideoPlayer
              key={'back'}
              className="back-video-container"
              mainUrl={videoUrl.back.main!}
              slaveUrl={videoUrl.back.slave!}
              direction={backDirection}
              videoId={2}
              slaveVideoId={502}
              vehicleName={vehicleName}
              warning={backWarning}
              needSendData={true}
              userName={userName}
              takeOverBySelf={takeOverBySelf}
              showOpenBtn={backVideoClosed}
              openVideo={openBackVideo}
              shouldLoad={shouldLoadBack}
              onVideoReady={handleVideoLoadComplete}
              onVideoTimeout={handleVideoLoadComplete}
            />
          )}
        </div>
        <div className="top-video-container">
          <div className="left video-item">
            {videoUrl.left && (
              <MainBackupVideoPlayer
                key={'left'}
                mainUrl={videoUrl.left.main!}
                slaveUrl={videoUrl.left.slave!}
                direction={leftDirection}
                videoId={3}
                slaveVideoId={503}
                vehicleName={vehicleName}
                warning={leftWarning}
                needSendData={true}
                takeOverBySelf={takeOverBySelf}
                userName={userName}
                showOpenBtn={leftVideoClosed}
                openVideo={openLeftVideo}
                shouldLoad={shouldLoadLeft}
                onVideoReady={handleVideoLoadComplete}
                onVideoTimeout={handleVideoLoadComplete}
              />
            )}
          </div>
          <div className="front video-item">
            {!isCollectionMode && (
              <div className="traffic-container">
                <TrafficLight />
                <div className="location-gps-wrapper">
                  <span className="location-signal">
                    <img className="location-icon" src={LocationIcon}></img>
                    <i
                      className={classNames('scene-signal', {
                        'scene-signal-red':
                          realtimeData?.sceneSignal >= 0 &&
                          realtimeData?.sceneSignal <= 3.5,
                      })}
                    >
                      {realtimeData?.sceneSignal ?? '--'}
                    </i>
                  </span>
                  <span className="divider"></span>
                  <span className="gps-signal">
                    <img className="gps-icon" src={gpsIcon}></img>
                    GPS
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="right video-item">
            {videoUrl.right && (
              <MainBackupVideoPlayer
                key={'right'}
                mainUrl={videoUrl.right.main!}
                slaveUrl={videoUrl.right.slave!}
                direction={rightDirection}
                videoId={1}
                slaveVideoId={501}
                vehicleName={vehicleName}
                warning={rightWarning}
                needSendData={true}
                userName={userName}
                takeOverBySelf={takeOverBySelf}
                showOpenBtn={rightVideoClosed}
                openVideo={openRightVideo}
                shouldLoad={shouldLoadRight}
                onVideoReady={handleVideoLoadComplete}
                onVideoTimeout={handleVideoLoadComplete}
              />
            )}
          </div>
        </div>
      </>
    ),
    [
      backDirection,
      backVideoClass,
      backVideoClosed,
      backWarning,
      frontVideoClass,
      frontWarning,
      gearPosition,
      gpsIcon,
      handleVideoLoadComplete,
      isCollectionMode,
      leftDirection,
      leftVideoClosed,
      leftWarning,
      openBackVideo,
      openLeftVideo,
      openRightVideo,
      realtimeData?.sceneSignal,
      rightDirection,
      rightVideoClosed,
      rightWarning,
      shouldLoadBack,
      shouldLoadLeft,
      shouldLoadRight,
      takeOverBySelf,
      userName,
      vehicleName,
      videoUrl,
    ]
  );

  const monitorSection = useMemo(() => {
    if (showThreeMonitorMap) {
      return (
        <ThreeMonitorMap
          vehicleName={vehicleName}
          runMapState={realtimeData?.runMapState}
          takeOverBySelf={takeOverBySelf}
          cockpitUserName={userName}
          signalQuality={realtimeData?.signalQuality}
          localViewStatus={realtimeData?.localViewStatus}
        />
      );
    }

    if (showCollectTaskCard) {
      return (
        <MapTaskCard realtimeData={realtimeData} vehicleName={vehicleName} />
      );
    }

    return null;
  }, [
    realtimeData?.localViewStatus,
    realtimeData?.runMapState,
    realtimeData?.signalQuality,
    showCollectTaskCard,
    showCollectTaskCard ? realtimeData : null,
    showThreeMonitorMap,
    takeOverBySelf,
    userName,
    vehicleName,
  ]);

  const centerSection = useMemo(() => {
    const alarmEventNameList = realtimeData?.alarmEventNameList || [];

    return (
      <div className="center-view">
        <StatusFields
          vehicleState={vehicleData.vehicleState}
          delay={vehicleData?.delay}
          cockpitMode={newCommon.cockpitMode}
          takeOverBySelf={takeOverBySelf}
          chargeState={realtimeData?.chargeState}
          chargerConnect={realtimeData?.chargerConnect}
          chargeLastRecordTime={realtimeData?.chargeLastRecordTime}
        />
        <div className="video-item back"></div>
        <div className="alarm-event-list">
          {alarmEventNameList.length <= 0 ? (
            <div className="no-alarm">暂无报警事件</div>
          ) : (
            <>
              <img
                className="warning-ico"
                src={require('@/assets/images/monitor/warning-icon.png')}
                width={55}
                height={55}
              />
              {alarmEventNameList.map((item: string) => {
                return (
                  <i
                    className={classNames('alarm-item', {
                      'full-width': alarmEventNameList.length === 1,
                    })}
                    key={item}
                  >
                    {translatorEnum('ALARM_EVENT_ENUM', item)}
                  </i>
                );
              })}
            </>
          )}
        </div>
        <TakeOver vehicleName={vehicleName} />
        <AcceleratorOpen
          vehicleName={vehicleName}
          cockpitNumber={cockpitNumber}
          takeOverBySelf={takeOverBySelf}
          userName={userName}
        />
        <div className="angle-dashboard-container">
          <Lights
            headLight={headLight}
            warningFlash={warningFlash}
            turnLeft={turnLeft}
            turnRight={turnRight}
            vehicleName={vehicleName}
            cockpitNumber={cockpitNumber}
            userName={userName}
            LC_BUTTON_UP={controlBtn.LC_BUTTON_UP}
            LC_BUTTON_DOWN={controlBtn.LC_BUTTON_DOWN}
            LC_BUTTON_LEFT={controlBtn.LC_BUTTON_LEFT}
            LC_BUTTON_RIGHT={controlBtn.LC_BUTTON_RIGHT}
          />
          <div className="angle-dashboard">
            <Dashboard
              type="angle"
              title="角度"
              currentValue={frontAngle}
              options={angleDashboardOptions}
            />
          </div>
        </div>
        <div className="speed-dashboard-container">
          <div className="speed-dashboard">
            <Dashboard
              type="speed"
              title="速度"
              unit="km/h"
              currentValue={speedValueText}
              options={speedDashboardOptions}
            />
          </div>
          <GearPosition
            value={gearPosition}
            sendRemoteCommand={sendRemoteCommand}
            takeOverBySelf={takeOverBySelf}
            vehicleName={vehicleName}
            LC_BUTTON_L1={controlBtn?.LC_BUTTON_L1}
            LC_BUTTON_SQUARE={controlBtn?.LC_BUTTON_SQUARE}
            LC_BUTTON_CIRCLE={controlBtn?.LC_BUTTON_CIRCLE}
            LC_BUTTON_R1={controlBtn?.LC_BUTTON_R1}
            newTakeover={newTakeover}
          />
        </div>
        <SpeedControl
          vehicleName={vehicleName}
          cockpitNumber={cockpitNumber}
          takeOverBySelf={takeOverBySelf}
          userName={userName}
          LC_BUTTON_TRIANGLE={controlBtn.LC_BUTTON_TRIANGLE}
          LC_BUTTON_CROSS={controlBtn.LC_BUTTON_CROSS}
        />
        <div className="enable-container">
          <Enable
            disabled={false}
            enable={enableState}
            enbaleLayout={enbaleLayout}
          />
        </div>
      </div>
    );
  }, [
    angleDashboardOptions,
    cockpitNumber,
    controlBtn.LC_BUTTON_CROSS,
    controlBtn.LC_BUTTON_DOWN,
    controlBtn.LC_BUTTON_LEFT,
    controlBtn.LC_BUTTON_RIGHT,
    controlBtn.LC_BUTTON_TRIANGLE,
    controlBtn.LC_BUTTON_UP,
    controlBtn?.LC_BUTTON_CIRCLE,
    controlBtn?.LC_BUTTON_L1,
    controlBtn?.LC_BUTTON_R1,
    controlBtn?.LC_BUTTON_SQUARE,
    enableState,
    frontAngle,
    gearPosition,
    headLight,
    newCommon.cockpitMode,
    newTakeover,
    realtimeData?.alarmEventNameList,
    sendRemoteCommand,
    speedDashboardOptions,
    speedValueText,
    takeOverBySelf,
    turnLeft,
    turnRight,
    userName,
    vehicleData,
    vehicleName,
    warningFlash,
  ]);

  const mapSection = useMemo(
    () => (
      <div className="standard-map">
        {!isCollectionMode && (
          <>
            <i
              className="toggle-icon"
              clstag={getClstag(
                newCommon.cockpitMode,
                'SinglePage_MapNavigation'
              )}
              onClick={handleOpenNavigation}
            ></i>
            <RealtimeMap
              ref={realtimeMapRef}
              vehicleName={vehicleName}
              zoom={15}
              updateGoneRoute={updateGoneRoute}
              etaInfo={etaInfo}
            />
          </>
        )}
        {showCollectTaskCard && (
          <CollectRouteMap
            latitude={realtimeData?.latitude}
            longitude={realtimeData?.longitude}
            taskRouteList={taskDetail?.taskRouteList}
            fourLaneIndexList={taskDetail?.fourLaneList}
            rotation={realtimeData?.realHeading}
            id={'collect-map-box'}
          />
        )}
      </div>
    ),
    [
      etaInfo,
      handleOpenNavigation,
      isCollectionMode,
      newCommon.cockpitMode,
      realtimeData?.latitude,
      realtimeData?.longitude,
      realtimeData?.realHeading,
      showCollectTaskCard,
      taskDetail?.fourLaneList,
      taskDetail?.taskRouteList,
      updateGoneRoute,
      vehicleName,
    ]
  );

  const operateSection = useMemo(
    () => (
      <div className="operate-btns">
        <ul className="left-btn-group">
          {!isCollectionMode && (
            <AsArrived
              vehicleName={vehicleName}
              cockpitNumber={cockpitNumber}
              takeOverBySelf={takeOverBySelf}
              pncTaskType={realtimeData?.pncTaskType}
              scheduleState={realtimeData?.scheduleState}
            />
          )}
          <Restart
            vehicleName={vehicleName}
            cockpitNumber={cockpitNumber}
            takeOverBySelf={takeOverBySelf}
          />
          <TakeoverSetting />
          <VehicleCommand
            vehicleName={vehicleName}
            cockpitNumber={cockpitNumber}
            takeOverBySelf={takeOverBySelf}
            audioUrl={videoUrl?.audio}
          />
        </ul>
        <div className="vehicle-name">
          <i
            style={{ color: '#fff', fontSize: '30px', fontFamily: 'JDZhengHT' }}
          >
            {vehicleName}
            {realtimeData?.stationName}
          </i>
          <i className="right-line"></i>
          <i
            className="go-back"
            onClick={goBack}
            clstag={getClstag(newCommon.cockpitMode, 'SinglePage_BackIcon')}
          ></i>
        </div>
        {showFooterWordOrder && (
          <ul className="right-btn-group">
            <WordOrderCommand
              vehicleName={vehicleName}
              LC_BUTTON_R2={controlBtn?.LC_BUTTON_R2}
              LC_BUTTON_L3={controlBtn?.LC_BUTTON_L3}
              isPageVisible={
                typeof document === 'undefined' ? true : !document.hidden
              }
            />
            <CallFrontLiner vehicleName={vehicleName} />
            <IssueHistoryBtn vehicleName={vehicleName} />
          </ul>
        )}
        {showCollectionTools && (
          <ul className="right-btn-group">
            <FinishCollectMap
              vehicleName={vehicleName}
              cockpitNumber={cockpitNumber}
              bindingState={realtimeData?.bindingState}
              taskId={realtimeData?.taskId}
              subTaskQuantity={realtimeData?.subTaskQuantity}
              heading={realtimeData?.realHeading}
              latitude={realtimeData?.latitude}
              longitude={realtimeData?.longitude}
              taskRouteList={taskDetail?.taskRouteList}
              fourLaneIndexList={taskDetail?.fourLaneList}
            />
            <EnterCollectMap
              vehicleName={vehicleName}
              cockpitNumber={cockpitNumber}
              systemState={realtimeData?.systemState}
              onClose={handleCollectMapLoading}
            />
            <CheckCollectRoute
              vehicleName={vehicleName}
              cockpitNumber={cockpitNumber}
            />
            <CheckSolidifiedData vehicleName={vehicleName} />
          </ul>
        )}
        {showCollectionControls && (
          <ul className="right-btn-group">
            <FinishCollectMap
              vehicleName={vehicleName}
              cockpitNumber={cockpitNumber}
              bindingState={realtimeData?.bindingState}
              taskId={realtimeData?.taskId}
              subTaskQuantity={realtimeData?.subTaskQuantity}
              heading={realtimeData?.realHeading}
              latitude={realtimeData?.latitude}
              longitude={realtimeData?.longitude}
              taskRouteList={taskDetail?.taskRouteList}
              fourLaneIndexList={taskDetail?.fourLaneList}
            />
            <ExitCollectMap
              vehicleName={vehicleName}
              cockpitNumber={cockpitNumber}
              taskId={realtimeData?.taskId}
              systemState={realtimeData?.systemState}
              onClose={handleCollectMapLoading}
            />
            {pauseOrResumeBtn}
            <CheckCollectRoute
              vehicleName={vehicleName}
              cockpitNumber={cockpitNumber}
            />
            <CheckSolidifiedData vehicleName={vehicleName} />
          </ul>
        )}
      </div>
    ),
    [
      cockpitNumber,
      controlBtn?.LC_BUTTON_L3,
      controlBtn?.LC_BUTTON_R2,
      goBack,
      handleCollectMapLoading,
      isCollectionMode,
      newCommon.cockpitMode,
      pauseOrResumeBtn,
      realtimeData?.bindingState,
      realtimeData?.latitude,
      realtimeData?.longitude,
      realtimeData?.pncTaskType,
      realtimeData?.realHeading,
      realtimeData?.scheduleState,
      realtimeData?.stationName,
      realtimeData?.subTaskQuantity,
      realtimeData?.systemState,
      realtimeData?.taskId,
      showCollectionControls,
      showCollectionTools,
      showFooterWordOrder,
      takeOverBySelf,
      taskDetail?.fourLaneList,
      taskDetail?.taskRouteList,
      vehicleName,
      videoUrl?.audio,
    ]
  );

  return (
    <div className="single-view-container">
      <Resolution
        takeOverBySelf={takeOverBySelf}
        videoMode={realtimeData?.videoMode}
        signalQuality={realtimeData?.signalQuality}
        videoAutoMode={realtimeData?.videoAutoMode}
        onChange={onChangeResolution}
      />
      {videoSection}
      <div className="bottom-control-container">
        {monitorSection}
        {centerSection}
        {mapSection}
      </div>
      <div className="footer"></div>
      {operateSection}
      <Spin fullscreen spinning={loading} size="large" />
      {/* 提示信息展示（浮层） */}
      <RemarkStack items={remarkItems} />
      <AEBAlertBar />
    </div>
  );
};

export default React.memo(SingleView);
